import { Box } from '@chakra-ui/react'
import type { FC, ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

import type { DomainBusinessContext } from '@app/types'

interface Props {
  loading?: boolean
  children?: ReactNode
  businessContext?: DomainBusinessContext
  title?: string
}

const ContextEditModal: FC<Props> = ({ businessContext, children, loading = false }) => {
  const navigate = useNavigate()

  if (loading || !businessContext) {
    return null
  }

  const handleClick = () => {
    navigate('edit-context')
  }

  return (
    <Box onClick={handleClick} cursor="pointer">
      {children}
    </Box>
  )
}

export default ContextEditModal
